import React from 'react';
import {connect} from 'react-redux';

// Components
import {loadLanguage} from 'Utils/jwtUtil';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

// Actions
import {getDeliverDetails} from 'Actions/host';
import {T} from 'Actions/translate';

class DeliverCard extends React.Component {
    state = {
        previewReceiveImageDialogOpened: false,
        uploadReceiveImageDialogOpened: false,
        cancelOrderDialogOpened: false,
        cancelWithdrawalPackage: false,
        waitSendGoodsDialogOpened: false,
        chooseShipmentItem: null,
        chooseImage: {file: null, url: ''},
        uploadFileBtnIsLoading: false,
        skuInventoryExitOpened: false,
        skuInventoryDetailData: [],
        sQuoteFailureDialogOpened: false,
        currentShipFlag: 0,
        currentShipmentId: '',
        currentOrderId: '',
        currentFinancialStatus: '',
        addTrackNumberDialogOpened: false,
        trackNumber: '',
        currentShipments: [],
        shipmentDetails: {},
    };

    componentWillMount() {
        // this.getInitData();
    }

    getInitData = () => {
        let search = this.props.location.search.substring(1);
        let arr = search.split('&');
        this.params = {};

        arr.forEach((item) => {
            let temp = item.split('=');

            this.params[temp[0]] = temp[1];
        });

        this.props
            .getDeliverDetails({orderId: parseInt(this.params.orderId)})
            .then((res) => {
                setTimeout(() => {
                    this.setState({
                        currentShipFlag: parseInt(this.params.shipFlag),
                        shipmentDetails: res.data,
                    });
                });
            });
    };

    goBack = () => {
        this.props.history.goBack();
    };

    ship = () => this.props.history.push(`/shipEdit/${this.params.orderId}`);
    openCancelOrderDialog = () =>
        this.setState({cancelOrderDialogOpened: true});

    dialogDidClose = (key) =>
        this.state[key] &&
        this.setState({chooseShipmentItem: null, [key]: false});

    closeDialog = (name) => {
        if (this.state.skuInventoryExitOpened) {
            this.setState({
                skuInventoryExitOpened: false,
                skuInventoryDetailData: [],
            });
        }
    };

    render() {
        const {} = this.state;
        const {kitSkuList, index, changeBtn} = this.props;
        return (
            <div className="deliver-card-container">
                <ul className="kit-sku-ul">
                    {kitSkuList.map((kitSkuItem, kitSkuIndex) => (
                        <li className="kit-sku-li" key={kitSkuIndex}>
                            <div className="parent-kit-sku">
                                <div className="first-row">
                                    <div>{kitSkuItem.sku}</div>
                                </div>
                                <div className="second-row">
                                    <div className="first-column">
                                        <label>
                                            {T('host_product_specifications')}
                                        </label>
                                        <span>{kitSkuItem.specifications}</span>
                                    </div>
                                    <div className="second-column">
                                        <label>
                                            {T(
                                                'shippment_details_shippment_quantity',
                                            )}
                                        </label>
                                        <span>{kitSkuItem.quantity}</span>
                                    </div>
                                </div>
                                <div className="second-row">
                                    <div className="first-column">
                                        <label>
                                            {T('product_storeCondition')}
                                        </label>
                                        <span>
                                            {kitSkuItem.storeCondition || '-'}
                                        </span>
                                    </div>
                                    <div className="second-column">
                                        <label>
                                            {T('product_shippingCondition')}
                                        </label>
                                        <span>
                                            {kitSkuItem.shippingCondition ||
                                                '-'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            {typeof kitSkuItem.skuItemList !== 'undefined' &&
                            kitSkuItem.skuItemList &&
                            kitSkuItem.skuItemList.length > 0 ? (
                                <ul className="sku-item-ul">
                                    {kitSkuItem.skuItemList.map(
                                        (skuItem, skuIndex) => (
                                            <li
                                                className="sku-item-li"
                                                key={skuIndex}>
                                                <div className="first-row">
                                                    <div className="first-column item-column">
                                                        <label className="">
                                                            {T(
                                                                'host_advent_products_item',
                                                            )}
                                                        </label>
                                                        <span className="">
                                                            {skuItem.item}
                                                        </span>
                                                    </div>
                                                    <div className="second-column">
                                                        <label className="">
                                                            {T(
                                                                'host_abnormal_nubmer_colon',
                                                            )}
                                                        </label>
                                                        <span className="">
                                                            {skuItem.quantity}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="second-row">
                                                    <div className="first-column">
                                                        <label className="">
                                                            {T(
                                                                'host_product_specifications',
                                                            )}
                                                        </label>
                                                        <span className="">
                                                            {
                                                                skuItem.specifications
                                                            }
                                                        </span>
                                                    </div>
                                                    <div className="second-column">
                                                        <label className="">
                                                            {T(
                                                                'shipment_sku_lot',
                                                            )}
                                                        </label>
                                                        <span className="">
                                                            {skuItem.lot}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="second-row">
                                                    <div className="first-column">
                                                        <label>
                                                            {T(
                                                                'product_storeCondition',
                                                            )}
                                                        </label>
                                                        <span>
                                                            {skuItem.storeCondition ||
                                                                '-'}
                                                        </span>
                                                    </div>
                                                    <div className="second-column">
                                                        <label>
                                                            {T(
                                                                'product_shippingCondition',
                                                            )}
                                                        </label>
                                                        <span>
                                                            {skuItem.shippingCondition ||
                                                                '-'}
                                                        </span>
                                                    </div>
                                                </div>
                                            </li>
                                        ),
                                    )}
                                </ul>
                            ) : null}
                        </li>
                    ))}
                </ul>
                {changeBtn ? (
                    <div
                        className="deliver-card-changeBtn"
                        onClick={() => {
                            this.props.switchBtn(index, 'less');
                        }}>
                        <ExpandLessIcon />
                    </div>
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host, localData} = state;
    return {
        deliverDetails: host.deliverDetails,
        localData,
    };
};

const mapDispatchToProps = {
    getDeliverDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliverCard);
